import Splide from "@splidejs/splide";

export class CarouselManager {
  static instances = new Map();

  static mountNow(element, options = {}) {
    const id = element?.dataset?.carouselId || element.id;
    if (!id) return null;
    if (this.instances.has(id)) return this.instances.get(id);

    const instance = new Splide(element, options);
    instance.mount();
    this.instances.set(id, instance);
    return instance;
  }

  static create(element, options = {}) {
    const splideList = element.querySelector(".splide__list");
    const id = element?.dataset?.carouselId || element.id;
    if (!id) return Promise.resolve(null);
    if (this.instances.has(id)) return Promise.resolve(this.instances.get(id));
  
    return new Promise(resolve => {
      const mediaQuery = window.matchMedia('(min-width: 640px)');
  
      const initCarousel = () => {
        resolve(this.mountNow(element, options));
        mediaQuery.removeEventListener('change', mediaChangeHandler);
      };
  
      const mediaChangeHandler = (e) => {
        if (e.matches) {
          initCarousel();
        }
      };
  
      const observer = new IntersectionObserver(
        entries => {
          if (!entries[0].isIntersecting) return;
  
          element.dispatchEvent(new CustomEvent("carousel:start-mount", { bubbles: false }));
  
          observer.disconnect();
  
          if (!splideList.classList.contains('free-scroll-on-mobile') || mediaQuery.matches) {
            initCarousel();
          } else {
            mediaQuery.addEventListener('change', mediaChangeHandler);
          }
        },
        {
          rootMargin: '50% 0px 100% 0px',
          threshold: 0,
        }
      );
  
      observer.observe(element);
    });
  }
  

  static destroy(id) {
    const instance = this.instances.get(id);
    if (instance) {
      instance.destroy();
      this.instances.delete(id);
    }
  }

  static cleanup() {
    this.instances.forEach((i) => i.destroy());
    this.instances.clear();
  }
}
